export default __webpack_public_path__ + "media/images/images/backgrounds/in-b2f5dcd663f5994fe34c2f79db334abc.jpg";